// [BD feat] Hero Teaser — bd-hero-teaser.js
// Intro screen (client, 2026-10-08): the "Enter / Video Teaser" frame (2881:2913 / 2976:3869) covers the
// page and locks scrolling until the pill is pressed; then the landing page (2976:3632 / 2978:4610) shows
// with the hero at the top. The rest of the page is inert while the intro is up.
// Skipped when the URL points at something on the page (e.g. #signup, a legal panel) and in the theme
// editor, where the teaser stays an ordinary section so every section below can be edited.
// bd-header.js keeps the header on the logo pill while the teaser covers the bar, and shows
// "GET IN EARLY" once it is gone — no extra wiring needed here.
// Client 2026-10-13: an own video for mobile (only the one for the screen size plays and downloads), a
// sound button (always starts muted), and a tap on the pill plays the whole toggle before the page opens.
// The background videos always autoplay, without a play button.
(function () {
  'use strict';

  var root = document.documentElement;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia ? window.matchMedia('(min-width: 60em)') : null;
  // The toggle's slide in general.css: 100ms delay + 850ms. The page opens once it has landed.
  var TOGGLE_MS = 950;

  function deepLinked() {
    var id = window.location.hash.slice(1);
    if (!id) return false;
    try { id = decodeURIComponent(id); } catch (e) { /* keep raw */ }
    return !!document.getElementById(id);
  }

  // Everything the intro covers: the other sections in <main>, the footer and the announcement bar
  function covered(section) {
    var own = section.closest('.shopify-section') || section;
    var list = [];
    var main = document.getElementById('MainContent');
    if (main) {
      Array.prototype.forEach.call(main.children, function (el) { if (el !== own) list.push(el); });
    }
    document.querySelectorAll('body > footer, .bd-announcement-bar').forEach(function (el) { list.push(el); });
    return list;
  }

  // The video for this screen size: the only one that plays (a separate mobile video, or the one for all)
  function activeVideo(section) {
    var want = desktop && desktop.matches ? 'desktop' : 'mobile';
    return section.querySelector('[data-bd-teaser-video="' + want + '"]') ||
      section.querySelector('[data-bd-teaser-video="all"]');
  }

  function initVideo(section) {
    var videos = Array.prototype.slice.call(section.querySelectorAll('[data-bd-teaser-video]'));
    if (!videos.length) return;
    var sound = section.querySelector('[data-bd-teaser-sound]');
    var soundOn = false;

    function sync() {
      var active = activeVideo(section);
      videos.forEach(function (video) {
        if (video === active) {
          video.muted = !soundOn;
          if (video.preload === 'none') video.preload = 'auto';
          video.autoplay = true;
          var playing = video.play();
          // Sound blocked by the browser: carry on muted and show the button as off
          if (playing && playing.catch) playing.catch(function () {
            if (!video.muted) { setSound(false); }
          });
        } else {
          video.muted = true;
          video.pause();
        }
      });
    }

    function setSound(on) {
      soundOn = on;
      if (sound) sound.setAttribute('aria-pressed', String(on));
      sync();
    }

    sync();
    if (desktop) {
      if (desktop.addEventListener) desktop.addEventListener('change', sync);
      else if (desktop.addListener) desktop.addListener(sync);
    }
    if (sound) sound.addEventListener('click', function () { setSound(!soundOn); });

    section.bdTeaserStop = function () {
      soundOn = false;
      videos.forEach(function (video) { video.muted = true; video.pause(); });
    };
  }

  function init(section) {
    if (section.dataset.bdIntroBound) return;
    section.dataset.bdIntroBound = '1';
    initVideo(section);
    if ((window.Shopify && window.Shopify.designMode) || deepLinked()) return;

    var button = section.querySelector('[data-bd-intro-enter]');
    if (!button) return;

    var behind = covered(section);
    behind.forEach(function (el) { el.inert = true; });
    section.classList.add('bd-hero-teaser--intro');
    root.classList.add('bd-intro-active');
    window.scrollTo(0, 0);

    // When the toggle started: hover (desktop) or the press itself (touch) — bd-motion.js runs it
    var toggleStart = null;
    var mark = function () { if (toggleStart === null) toggleStart = Date.now(); };
    var unmark = function () { if (!button.classList.contains('bd-hero-teaser__cta--entering')) toggleStart = null; };
    button.addEventListener('mouseenter', mark);
    button.addEventListener('pointerdown', mark);
    button.addEventListener('focusin', mark);
    button.addEventListener('mouseleave', unmark);
    button.addEventListener('focusout', unmark);

    var going = false;
    function go() {
      if (going) return;
      going = true;
      mark();
      button.classList.add('bd-hero-teaser__cta--entering', 'bd-motion-in');
      // The unlock (client 2026-10-14: "the feeling of opening a lock, and then once it's full, an intuitive
      // delay before the page opens"). Pressed from rest (touch, keyboard, a click without hover) the dots
      // run the latch keyframes (CSS --bolt); after a hover they finish the hover slide. Once in place the
      // pill fills (--unlocked), holds for the "Pause after unlock" setting, then the page opens.
      if (reduced) { enter(); return; }
      var icon = button.querySelector('[data-bd-motion-traveller]');
      var pause = parseInt(button.getAttribute('data-bd-unlock-pause'), 10);
      if (isNaN(pause)) pause = 450;
      var unlocked = false;
      var unlock = function () {
        if (unlocked) return;
        unlocked = true;
        button.classList.add('bd-hero-teaser__cta--unlocked');
        window.setTimeout(enter, pause);
      };
      var elapsed = Date.now() - toggleStart;
      if (!icon || elapsed >= TOGGLE_MS) { unlock(); return; }
      if (elapsed < 80) {
        button.classList.add('bd-hero-teaser__cta--bolt');
        icon.addEventListener('animationend', function onEnd(e) {
          if (e.target !== icon) return;
          icon.removeEventListener('animationend', onEnd);
          unlock();
        });
        window.setTimeout(unlock, 900); // no animationend (e.g. background tab) → unlock anyway
        return;
      }
      icon.addEventListener('transitionend', function onEnd(e) {
        if (e.target !== icon || e.propertyName !== 'transform') return;
        icon.removeEventListener('transitionend', onEnd);
        unlock();
      });
      window.setTimeout(unlock, TOGGLE_MS + 100); // no transitionend (e.g. background tab) → unlock anyway
    }

    button.addEventListener('click', go);
    // Pressing commits (client 2026-10-14): holding the pill down slid the dots to the end and then nothing
    // happened until the button was released, and releasing off the pill opened nothing at all. The press
    // starts the entry; the page opens once the slide has landed (+ the short beat in go()), held or not.
    button.addEventListener('pointerdown', function (e) {
      if (e.button === 0) go();
    });
    // Touch: the press itself already starts the toggle (a hover-style change), and iOS Safari then swallows
    // the click of that first tap — the dots slid but the page never opened. Lifting the finger on the pill
    // enters straight away; the click that may follow is ignored.
    button.addEventListener('pointerup', function (e) {
      if (e.pointerType === 'mouse') return;
      var hit = document.elementFromPoint(e.clientX, e.clientY);
      if (hit && button.contains(hit)) go();
    });

    function enter() {
      behind.forEach(function (el) { el.inert = false; });
      root.classList.remove('bd-intro-active');
      window.scrollTo(0, 0);

      var heading = document.querySelector('.bd-hero h1');
      if (heading) {
        if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true, focusVisible: false });
      }

      var done = function () {
        section.hidden = true;
        if (section.bdTeaserStop) section.bdTeaserStop();
      };
      if (reduced) { done(); return; }
      section.addEventListener('transitionend', function onEnd(e) {
        if (e.target !== section) return;
        section.removeEventListener('transitionend', onEnd);
        done();
      });
      window.setTimeout(done, 700); // no transitionend (background tab) → hide anyway
      section.classList.add('bd-hero-teaser--leaving');
    }
  }

  function scan() { document.querySelectorAll('[data-bd-intro]').forEach(init); }

  // Autoplay: a browser that held the muted background videos back (iOS Low Power Mode, data saver)
  // starts them on the first touch or click anywhere on the page. Only videos on screen — the other
  // half of a desktop/mobile pair stays unloaded.
  function kick() {
    document.querySelectorAll('.bd-hero-teaser__video, .bd-hero__video').forEach(function (video) {
      if (!video.paused || !video.getClientRects().length) return;
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
    });
  }
  document.addEventListener('pointerdown', kick, { once: true, capture: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();
// [BD feat] Hero Teaser
